import fetch from '@/utils/request';
import { deepCopy, formatDate } from 'utils/index';
import { sift_query_list } from 'utils/sift';
const ls = process.env.NODE_ENV === 'development' ? '/larkswitch' : '';
// const ls = '';

// ! 来电列表查询
export function apiPostCallIbContactList(data){
	data = deepCopy(data);
	if(data.date) {
		data.startDate = formatDate(data.date[0], 'YYYY-MM-DD');
		data.endDate = formatDate(data.date[1], 'YYYY-MM-DD');
	} else {
		const year = new Date().getFullYear();
		const month = new Date().getMonth();
		const date = new Date().getDate();
		switch(data.showTypeTem) {
			case '我的通话':
			case '今天': {
				data.startDate = formatDate(new Date(), 'YYYY-MM-DD');
				data.endDate = formatDate(new Date(), 'YYYY-MM-DD');
				break;
			}
			case '昨天': {
				data.startDate = formatDate(new Date(year, month, date - 1), 'YYYY-MM-DD');
				data.endDate = formatDate(new Date(year, month, date - 1), 'YYYY-MM-DD');
				break;
			}
			case '近三天': {
				data.startDate = formatDate(new Date(year, month, date - 2), 'YYYY-MM-DD');
				data.endDate = formatDate(new Date(), 'YYYY-MM-DD');
				break;
			}
			case '近七天': {
				data.startDate = formatDate(new Date(year, month, date - 6), 'YYYY-MM-DD');
				data.endDate = formatDate(new Date(), 'YYYY-MM-DD');
				break;
			}
		}
	}
	delete data.date;
	delete data.showTypeTem;
    return fetch({
        url: '/call/ib/contact/historyList.json',
        method: 'post',
        data: sift_query_list(data),
		contentType: 'formData'
    });
}

// ! 查询来电信息
export function apiPostCallIbContact(histId){
    return fetch({
        url: `/call/ib/contact/query/${histId}`,
        method: 'post',
		contentType: 'formData'
    });
}

// ! 获取当前来电信息
export function apiPostMemberCallInfo(data) {
	return fetch({
        // url: `/larkswitch/project/manage/member/getCurrentCallInfo.json`,
		url: `${ls}/project/manage/member/getCurrentCallInfo.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 新增来电记录
export function apiPostAddCallHistory(data) {
	return fetch({
        url: `/call/ib/contact/addHistory.json`,
        method: 'post',
		data: data,
		contentType: 'formData'
    });
}

// ! 来电记录修改
export function apiPostCallContactEdit(data) {
	return fetch({
        url: `/call/ib/contact/edit.json`,
        method: 'post',
		data: sift_query_list(data),
		contentType: 'formData'
    });
}

// ! 根据品牌查询外显号码列表
export function apiPostSelectQueryCallERlist(data) {
	return fetch({
        // url: `/larkswitch/project/account/quryCallerList.json`,
		url: `${ls}/project/account/quryCallerList.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 查询归属地
export function apiPostQueryPhoneBelonging(data) {
	return fetch({
		// /call/ib/contact/queryBelonging.json
        url: `/call/ib/contact/queryPhoneBelonging.json`,
        method: 'post',
		data: data,
		contentType: 'formData'
    });
} 

// ! 查询归属地（新）
export function apiPostQueryBelonging(data) {
	return fetch({
        url: `/call/ib/contact/queryBelonging.json`,
        method: 'post',
		data: data,
		contentType: 'formData'
    });
} 

// ! 查询号码是否外地
export function apiPostSelectForeign(data) {
	return fetch({
        url: `/call/ib/contact/selectForeign.json`,
        method: 'post',
		data: data,
		contentType: 'formData'
    });
} 

// ! 查询agent电话相关信息
export function apiPostCallAgentInfo(data){
    return fetch({
        // url: `/larkswitch/project/manage/agent/getInfo.json`,
		url: `${ls}/project/manage/agent/getInfo.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 根据项目查询置忙/置闲状态列表
export function apiPostCallAuxList(data){
    return fetch({
        // url: `/larkswitch/project/manage/aux/list.json`,
		url: `${ls}/project/manage/aux/list.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}


// ! 签入
export function apiPostCallSignIn(data){
    return fetch({
        // url: `/larkswitch/project/manage/agent/ext/signIn.json`,
		url: `${ls}/project/manage/agent/ext/signIn.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 签出
export function apiPostCallSignOut(data){
    return fetch({
        // url: `/larkswitch/project/manage/agent/ext/signOut.json`,
		url: `${ls}/project/manage/agent/ext/signOut.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 置闲
export function apiPostCallSetWaiting(data){
    return fetch({
        // url: `/larkswitch/project/manage/agent/ext/setWaiting.json`,
		url: `${ls}/project/manage/agent/ext/setWaiting.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 置忙
export function apiPostCallSetBusy(data){
    return fetch({
        // url: `/larkswitch/project/manage/agent/ext/setBusy.json`,
		url: `${ls}/project/manage/agent/ext/setBusy.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 会议
export function apiPostCallThreeWay(data){
    return fetch({
        // url: `/larkswitch/project/manage/member/threeway.json`,
		url: `${ls}/project/manage/member/threeway.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 保持
export function apiPostCalSipHold(data){
    return fetch({
        // url: `/larkswitch/sip/phone/sipHold.json`,
		url: `/sip/phone/sipHold.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 挂断
export function apiPostCallSipPhoneHangUp(data){
    return fetch({
        // url: `/larkswitch/sip/phone/sipPhoneHangUp.json`,
		url: `${ls}/sip/phone/sipPhoneHangUp.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 外呼
export function apiPostCallSipPhoneOutbound(data){
    return fetch({
        // url: `/larkswitch/sip/phone/sipPhoneOutbound.json`,
		url: `${ls}/sip/phone/sipPhoneOutbound.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 按键
export function apiPostCallSipSendDtmf(data){
    return fetch({
        // url: `/larkswitch/sip/phone/sipSendDtmf.json`,
		url: `${ls}/sip/phone/sipSendDtmf.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 转接
export function apiPostCallSipTransfer(data){
    return fetch({
        // url: `/larkswitch/sip/phone/sipTransfer.json`,
		url: `${ls}/sip/phone/sipTransfer.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 恢复
export function apiPostCallSipUnHold(data){
    return fetch({
        // url: `/larkswitch/sip/phone/sipUnhold.json`,
		url: `${ls}/sip/phone/sipUnhold.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}


// ! 日志
export function apiPostAddTelLog(data){
    return fetch({
        url: `/call/cti/operationLog/add.json`,
        method: 'post',
		data: data,
		contentType: 'formData'
    });
}

// ! 根据品牌查询技能组列表
export function apiPostQueueSelectList(data){
    return fetch({
        // url: `/larkswitch/project/manage/queue/selectList.json`,
		url: `${ls}/project/manage/queue/selectList.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 查询工号所属技能组
export function apiPostAgentTierList(data){
    return fetch({
        // url: `/larkswitch/project/manage/agent/tierList.json`,
		url: `${ls}/project/manage/agent/tierList.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 生成工号和分机
export function apiPostCreateAgentAndExtens(data){
    return fetch({
        // url: `/larkswitch/project/manage/agentAndExtens/create.json`,
		url: `${ls}/project/manage/agentAndExtens/create.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 添加账号到技能组
export function apiPostAddTierAccount(data){
	if(!data.queueName) return;
    return fetch({
        // url: `/larkswitch/project/manage/tier/account/add.json`,
		url: `${ls}/project/manage/tier/account/add.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 账号从技能组删除
export function apiPostDeleteTierAccount(data){
	if(!data.queueName) return;
    return fetch({
        // url: `/larkswitch/project/manage/tier/account/delete.json`,
		url: `${ls}/project/manage/tier/account/delete.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 获取坐席列表
export function apiPostProjectExtensList(data){
    return fetch({
        // url: `/larkswitch/project/extens/listByProjectCode.json`,
		url: `${ls}/project/extens/listByProjectCode.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 更改外显号码
export function apiPostProjectExtensEditDevice(data){
    return fetch({
        // url: `/larkswitch/project/extens/editDevice.json`,
		url: `${ls}/project/extens/editDevice.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 转接会议
export function apiPostManageMemberThreeway(data){
    return fetch({
        // url: `/larkswitch/project/manage/member/threeway.json`,
		url: `${ls}/project/manage/member/threeway.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 获取工号登录状态
export function apiPostManageAgentSingStatus(data){
    return fetch({
        // url: `/larkswitch/project/manage/agent/getSignStatus.json`,
		url: `${ls}/project/manage/agent/getSignStatus.json`,
        method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
    });
}

// ! 上传录音文件
export function apiAddIncidentData(data) {
	return fetch({
		url: '/ia/incident/addIncidentData.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 查询坐席状态
export function apiGetAgentStatus(data) {
	return fetch({
		// url: '/larkswitch/project/manage/agent/getStatus.json',
		url: `${ls}/project/manage/agent/getStatus.json`,
		method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	});
}

// ! 获取留言列表
export function apiLeavemsgList(data) {
	data = deepCopy(data);
	if(data.date) {
		data.startTime = formatDate(data.date[0], 'YYYY-MM-DD HH:mm:ss');
		data.endTime = formatDate(data.date[1], 'YYYY-MM-DD HH:mm:ss');
	}
	delete data.date;
	return fetch({
		url: '/project/leavemsg/leaveMsg.json',
		method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	});
}

// ! 获取通话记录
export function apiPostRecording(data, lark) {
	data = deepCopy(data);
	if(data.date) {
		data.startTime = formatDate(data.date[0], 'YYYY-MM-DD HH:mm:ss');
		data.endTime = formatDate(data.date[1], 'YYYY-MM-DD HH:mm:ss');
	}
	if(data.date2) {
		data.answerTime = formatDate(data.date2[0], 'YYYY-MM-DD HH:mm:ss') + ',' + formatDate(data.date2[1], 'YYYY-MM-DD HH:mm:ss');
	}
	if(data.date3) {
		data.hangUpTime = formatDate(data.date3[0], 'YYYY-MM-DD HH:mm:ss') + ',' + formatDate(data.date3[1], 'YYYY-MM-DD HH:mm:ss');
	}
	delete data.date;
	delete data.date2;
	delete data.date3;
	return fetch({
		url: `${lark}/project/recording/list.json`,
		// url: '/lark_dn/project/recording/list.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 通话记录导出
export function apiGetRecordingExport(data, lark) {
	data = deepCopy(data);
	if(data.date) {
		data.startTime = formatDate(data.date[0], 'YYYY-MM-DD HH:mm:ss');
		data.endTime = formatDate(data.date[1], 'YYYY-MM-DD HH:mm:ss');
	}
	delete data.date;
	return fetch({
		url: `${lark}/project/recording/download.json`,
		// url: '/lark_dn/project/recording/download.json',
		method: 'get',
		params: data,
		responseType: 'blob'
	});
}

// ! 留言回拨
export function apiPostMsgCallBackResult(data) {
	return fetch({
		url: '/project/leavemsg/saveLeaveMsgCallbackResult.json',
		method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	});
}

// ! 电话挂断自动发送短信
export function apiPostAutomaticSendSms(data) {
	return fetch({
		url: '/ocs-sms/saveQuickSmsnoia',
		method: 'post',
		data: data,
	});
}